<template>
  <svg
    id="TLogo"
    data-name="TLogo"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 600 388.7"
  >
    <g id="a">
      <path
        :class="class2"
        d="M390.1 305.4h39.8v17.3h-39.8zM0 347.5h15.6v41.1H0zM27.2 347.5h15.6v41.1H27.2zM54.4 347.5H70v41.1H54.4zM0 316.3h205.7v17.3H0zM0 286.3h205.7v17H0zM0 256.1h205.7v17H0zM0 201h15.6v41.2H0zM27.2 201h15.6v41.2H27.2zM54.4 201H70v41.2H54.4zM0 161.2h205.7v17H0zM0 130.9h205.7v17.3H0zM0 100.7h205.7V118H0zM224.2 203.4h205.7v17H224.2zM224.2 233.6h205.7v17H224.2zM224.2 305.4h69.7v17.3h-69.7z"
      />
      <path
        :class="class2"
        d="M224.2 263.6v17h82.9v42.1h15.7v-42.1h11.5v42.1H350v-42.1h11.2v42.1h16v-42.1h52.7v-17H224.2zM224.2 335.6h205.7v17.3H224.2zM224.2 365.9h205.7v17H224.2z"
      />
    </g>
    <g id="b">
      <path
        :class="class1"
        d="M142.8 0c-19 0-33.3 7.1-42.8 20.7-9.9-6.5-22.4-9.5-37.7-9.5C22.1 11.2 0 35.4 0 80.9v5.8h15.3v-5.1c0-34.3 16-53.4 46.6-53.4s47.6 16 47.6 52v6.5h15v-5.8c0-7.8-.7-14.6-1.7-21.1 4.1-7.5 11.2-12.2 19.7-12.2 13.9 0 20.4 7.1 20.4 21.4v17.7h15.3v-17c0-25.5-12.9-39.1-35.4-39.1s-20.1 4.4-25.2 11.9c-1.7-4.1-3.7-7.8-6.5-11.2 7.1-9.5 17.3-14.3 31.3-14.3 32 0 47.9 17.3 47.9 52v17.7h15.3v-17C205.7 23.8 185 0 142.8 0Z"
      />
      <path
        :class="class1"
        d="M62.2 41.5c-22.8 0-34.3 12.9-34.3 37.7v7.5h15v-8.5c0-12.9 6.8-19.4 19-19.4s19.7 6.1 19.7 20.1v7.8h15.3v-7.5c0-24.8-11.9-37.7-34.7-37.7Z"
      />
      <path
        :class="class1"
        d="M62.2 71.8c-4.1 0-6.8 2.7-6.8 7.5v7.5H69v-7.5c0-5.1-2-7.5-6.8-7.5ZM143.5 61.2c-4.4 0-6.5 2-6.5 7.1v18.4h13.3V68.3c0-5.1-2-7.1-6.8-7.1ZM282.6 68.7V51.4c-21.4 0-37.4 19-37.4 44.5s16.7 48 42.8 48.3c23.1.3 37.4-13.6 42.8-39.8l2.7-14.3c4.1-19.7 12.9-28.6 29.2-28.6S394 75.1 394 98.2s-9.9 32-26.2 32v17.7c24.8 0 41.2-20.1 41.2-49s-17.3-53.7-46.6-53.7-38.1 14.3-42.8 41.2l-2.7 14.3c-3.4 18.4-12.6 26.9-28.9 26.9-17.7-.3-28.2-11.9-28.2-31.6s10.2-27.2 22.8-27.2Z"
      />
      <path
        :class="class1"
        d="M368 117.3c9.5 0 14.6-7.1 14.6-20.1s-8.2-22.4-20.1-22.4-16 5.4-18.4 17.7l-2.7 15c-6.8 33.3-23.1 50-52 49.7-37.1-.3-55.8-20.7-55.8-61.2s17-57.5 49-57.5V21.2c-40.8 0-63.9 27.9-63.9 74.8s25.8 77.2 71.1 77.5c35 .3 58.8-23.1 66-61.9l2.4-15c.7-3.7 2.7-4.8 4.8-4.8 3.4 0 5.1 2 5.1 7.1v18.4Z"
      />
      <path
        :class="class1"
        d="M359.8 15c-35.7 0-58.1 23.1-65 64.6l-2.4 13.9c-.7 3.1-2.4 4.8-4.8 4.8-3.4 0-5.1-1.7-5.1-6.5V79.9c-6.8 0-11.2 6.5-11.2 16s7.5 18 16.7 18 16-4.8 18.4-16.7l2.7-13.9c6.1-34.3 23.5-51.3 52-51.3s59.2 22.4 59.2 68-18 61.6-52.4 61.6v17.7c42.2 1.7 67.3-28.6 67.3-78.6S407.3 15 359.7 15ZM522.3 302.7c-23.5 0-36.1 12.2-37.1 36h13.6c1-12.6 10.5-20.4 24.8-20.4s26.2 7.8 27.2 20.4h13.9c-1.4-23.5-16-36-42.5-36Z"
      />
      <path
        :class="class1"
        d="M539 344.8c0-7.5-6.5-13.6-13.9-13.6s-14.3 6.1-14.3 13.6 6.1 13.6 14.3 13.6 13.9-5.8 13.9-13.6Z"
      />
      <path
        :class="class1"
        d="M524.3 371.4c-15.3 0-24.5-7.8-25.5-21.1h-13.6c1 23.1 15.3 36.7 39.4 36.7s38.8-11.2 40.1-36.7h-13.9c-.7 14.3-9.9 21.1-26.5 21.1ZM524.5 227.3c-15.7 0-23.6-4.3-23.6-12.4s3.8-11.2 18.1-11.2v-12.4c-21 .2-29 7.1-29 23.6s11.9 24.5 34.8 24.5 35.2-7.9 35.2-24.5-9.5-23.3-30.2-23.6v12.4c12.9 0 19 3.6 19 11.2s-7.9 12.4-24.3 12.4Z"
      />
      <path
        :class="class1"
        d="M470 215c0 28.3 20.5 46.2 54.8 46.2s55.2-16 55.2-46.2-16.2-43.8-50.2-44v12.1c27.9 0 39 8.8 39 31.9s-13.8 33.8-44.5 33.8S481 236.7 481 215s10.5-32.1 38.1-32.1V171c-33.6.2-49 14-49 44Z"
      />
      <path
        :class="class1"
        d="M529.8 149.7v12.1c41.4 0 59 15.7 59 53.1s-20 55.7-64.5 55.7S461 252 461 214.9s17.6-53.1 58.1-53.1v-12.1c-46.4.2-69 21.2-69 65.2s25.7 67.8 74.7 67.8 75.2-21.4 75.2-67.8-23.8-65-70.2-65.2ZM524.3 55.5c17.1 0 23.6 2.6 23.6 9h11c0-15-10.2-21.4-34-21.4s-33.8 6.7-33.8 21.4h11c0-6.4 6.9-9 22.4-9Z"
      />
      <path
        :class="class1"
        d="M524.8 21.7C488.9 21.7 471 36 471 64.5h11c0-20.9 13.8-30.7 42.6-30.7s43.3 8.6 43.3 30.7h10.9c0-29.5-16.9-42.8-54-42.8Z"
      />
      <path
        :class="class1"
        d="M524.5 12.1c45 0 63.3 14.5 63.3 52.4h11c0-45.2-22.8-64.5-74-64.5S451 22.4 451 64.5h11c0-35 20-52.4 62.6-52.4ZM524.8 95.5c24.3 0 34-6.2 34-21.2h-11c0 6.4-5.9 8.8-23.6 8.8s-22.4-2.4-22.4-8.8h-11c0 14.3 10.5 21.2 33.8 21.2Z"
      />
      <path
        :class="class1"
        d="M481.9 74.3h-11c0 27.4 19.5 42.6 53.8 42.6s54-13.6 54-42.6h-10.9c0 21.9-11.9 30.5-43.3 30.5s-42.6-9.3-42.6-30.5Z"
      />
      <path
        :class="class1"
        d="M524.8 138.5c52.6 0 74-19 74-64.3h-11c0 36.9-17.8 52.1-63.3 52.1s-62.6-16.2-62.6-52.1h-11c0 42.6 25.5 64.3 73.8 64.3Z"
      />
    </g>
  </svg>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "TLogo",
  props: {
    class1: { type: String, default: "class1" },
    class2: { type: String, default: "class2" },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss">
.class1 {
  fill: var(--q-dark);
}
.class2 {
  fill: #fff;
}
.class3 {
  fill: var(--q-primary);
}
</style>
